// Save an in-memory file (CSV, PDF…) through the browser's download.
//
// Safari reads a blob: URL asynchronously AFTER the click returns, so revoking it straight away
// cancels the download ("Unknown — Zero KB of N KB — stopped" in Safari's Downloads list). Keep the
// URL alive for a while and attach the link to the document (some browsers ignore clicks on a
// detached anchor).
export const BLOB_URL_TTL_MS = 60_000;

export const saveBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), BLOB_URL_TTL_MS);
};
